
import React from 'react';
import $ from 'jquery'; 
import pump from './pump.png';
import map from './map.png';
import near from './near.png';
import me from './me.png';
// eslint-disable-next-line
{/*Above: Import necessary packages and images*/}
// eslint-disable-next-line
{/*Create class and component*/}
class Favourites extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      /*Data is in an array*/
      data: []
    };
  }
  
  /*Do when component hits DOM*/
  componentDidMount() {
  	// eslint-disable-next-line
  	{/*Get lat long and save to localstorage*/}

  	function getLocation() {
		navigator.geolocation.watchPosition(showPosition);
	}

	function showPosition(position) {
		localStorage.setItem("lat", position.coords.latitude);
		localStorage.setItem("long", position.coords.longitude);
	};

	getLocation();
	var lat = localStorage.getItem("lat");
	var long = localStorage.getItem("long");

	var url = 'https://api.openchargemap.io/v2/poi/?client=ocm.app.web.5.2.7_20151008&verbose=false&output=json&operator=3&latitude='+lat+'&longitude='+long+'&distance=10&distanceunit=miles&maxresults=10';

  	  // eslint-disable-next-line
  	  {/*AJAX request to API URL once URL formed*/}
  	  if (long == null){
  	  	console.log("Do nowt");
  	  }
  	  else {
	   	  $.ajax({
	      url: url,
	  	  /*We'd like json please*/
	      dataType: 'json',
	      /*Set state on success and console log on fail*/
	      success: function(data) {
	        this.setState({data: data});
	      }.bind(this),
	      error: function(xhr, status, err) {
	        console.error('#GET Error', status, err.toString());
	      }
	    });
	}
  }
  
  /*Render the following code*/
  render() {
  	// eslint-disable-next-line
  	{/*Check if data has transferred from API*/}
    if (this.state.data.length > 0) {
      return (
      		/*Bootstrap container*/
	        <div className="container">
	        	{/*HTML5 semantic header*/}
	        	<header>
	        		<h1 className="text-center">EV Chargers Near You</h1>
	        		<p className="text-center">Location not accurate? <br /><a href="https://evlocations-4717e.firebaseapp.com/" title="Refresh">Tap here</a> to reload (may take a few seconds).</p>
	        	</header>
	        	{/*Using div because rows are purely presentational*/}
	        	<div className="row">
	        		{/*HTML5 semantic nav container*/}
		        	<nav className="col-12 text-center">
		        		{/*Using "A" because the link is active. Would also convert button in production app, but for now we'll leave it as it's semantically more correct*/}
		        		{/*For the prototype, empty pages are linked as statics. Routing would be best in production, as only the body content and button states will change.*/}
		        		<a href="http://www.evchargehelper.co.uk" title="Calculator" className="btn btn-primary">Calculator</a>
		        		<button className="btn btn-success">Chargers</button>
		        	</nav>
		        </div>
		        <div className="row">
		        		{/*Start of chargers list. 12 of 12 columns wide.*/}
			        	<ul className="col-12">
					        	{
					        		/*Iterate through all items and do the following with them...*/
						            this.state.data.map(function (chargers) {
						              // eslint-disable-next-line
						              {/*Enclosing jsx tag*/}
						              return <>
						              			{/*LI is semantically correct here*/}
						              			{/*Nesting a row so we can split content into columns within the li*/}
						              			<a href={'geo:' + chargers.AddressInfo.Latitude + ',' + chargers.AddressInfo.Longitude + '?q=' + chargers.AddressInfo.Title}>
							              			<li className="row">
								              				{/*We're using spans to separate elements, so not "breaking the rules" by including block-level elements within an li*/}
								              				{/*Pod icon occupies 2 of 12 columns on the grid*/}
									              		<span className="col-2">
									              				{/*Fetches the "pump" image from our imports*/}
									              			<img src={pump} alt="EV charger icon" />
									              		</span>

									              		{/*Charger data occupies the centre 8 columns, provides spacing before distance data*/}
									              		<span className="col-8">
									              			{/*First data from API, looking for charger name*/}
									              			{chargers.AddressInfo.Title}
									              			<br />
									              			{/*Grey class for styling*/}
									              			<span className="grey">
									              				{/*First line of charger address & postcode*/}
									              				{chargers.AddressInfo.AddressLine1} - {chargers.AddressInfo.Postcode}
									              			</span>
									              		</span>
									              		{/*Last 2 columns of grid, applying "grey" class for upper margin*/}
									              		<span className="col-2 grey">
									              			{/*Truncate distance with CSS, apply grey class again to prevent override*/}
									              			<span className="truncated grey">
									              				{/*User distance from charger in miles*/}
									              				{chargers.AddressInfo.Distance}
									              			</span>
															{/*Unit of measurement*/}
									              			mi
									              		</span>
							              			</li>
						              			</a>
												{/*Line below each charger*/}
						              			<hr />
						              		{/*JSX closing tag*/}
						              		 </>
						            })
					        	}
			        	</ul>
		        </div>
       		</div>
      );
    }
    // eslint-disable-next-line
    {/*Display while loading chargers*/}
    return (<p className="startMessage"> <br /><strong>Loading chargers - this should take a few seconds.</strong><br /><br /> If it is your first time using this feature, please <a href="https://evlocations-4717e.firebaseapp.com/" title="tap here">tap here</a> to continue.</p>);
  }
}

// eslint-disable-next-line
{/*Expose Favourites component if required*/}
export default Favourites;